import { render, staticRenderFns } from "./division.vue?vue&type=template&id=128099f4&scoped=true&"
import script from "./division.vue?vue&type=script&lang=js&"
export * from "./division.vue?vue&type=script&lang=js&"
import style0 from "./division.vue?vue&type=style&index=0&id=128099f4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128099f4",
  null
  
)

export default component.exports